let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fRURW")).then(() => parcelRequire('6AKc1'));